<template>
	<v-card v-if="currentModalFilter === 'sort'" class="sort-modal-container">
		<div
			@input="(v) => v || closeModal()"
			v-click-outside="closeModal"
			class="filter-modal-wrapper"
		>
			<v-progress-circular v-if="sortLoading" :size="20" :width="3"></v-progress-circular>
			<div
				v-else
				v-for="item in currentSortList"
				:key="item.field"
				@click="handleSortItemChange(item.field)"
				class="filter-modal__sort__input"
				:class="{ active: isInputActive('sort', item.field) }"
			>
				<label class="filter-modal__input-label">
					{{ item.title }}
				</label>
			</div>
		</div>
	</v-card>
	<v-dialog
		v-else
		v-model="filterModalIsVisible"
		scroll-strategy="block"
		max-width="600"
		@input="(v) => v || closeModal()"
		content-class="filter-modal"
		@click:outside="closeModal"
	>
		<v-card class="filter-modal__card">
			<div class="d-flex align-center flex-wrap">
				<div class="filter-modal__card__close" @click="closeModal">
					<Icon :size="24" type="close" color="var(--primary_color)" />
				</div>
				<div class="filter-modal__title">
					{{ currentModalLabel }}
					<div
						class="filter-modal__progress d-flex justify-center align-center py-6"
						v-if="isFiltersLoading"
					>
						<v-progress-circular indeterminate :size="25" :width="3" />
					</div>

					<div
						v-if="currentModalFilter === 'tags'"
						:style="{
							border:
								isInputFocused || searchText
									? '1px solid var(--vote_bar_tint)'
									: '1px solid #e2e2e2',
						}"
						class="app-top-bar__search-wrapper search"
					>
						<input
							class="app-top-bar__search"
							type="text"
							v-model="searchText"
							placeholder="Search"
							@focus="isInputFocused = true"
							@blur="isInputFocused = false"
						/>
						<Icon type="search" color="var(--button-icon-tint)" :size="24" />
					</div>
				</div>
			</div>

			<div
				class="filter-modal__container mb-3 mt-5"
				ref="filterContainer"
				@scroll="handleScroll"
			>
				<div v-if="currentModalFilter === 'chapters' && chapters" class="pb-3">
					<div
						class="filter-modal__input"
						v-for="item in chapters"
						:key="item.chapter_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('chapters', item.chapter_id)"
							:value="item.chapter_id"
							:onChange="() => setItem('chapters', item.chapter_id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.chapter_name }}
						</label>
					</div>
				</div>

				<div style="height: 500px" v-if="currentModalFilter === 'tags'" class="pb-3">
					<div
						class="speaker-filter__wrapper__empty"
						v-if="computedTags.length === 0 && !isFiltersLoading"
					>
						Not found.
					</div>
					<div
						class="filter-modal__input"
						v-for="item in computedTags"
						:key="item.tag_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('tags', item.tag_id)"
							:value="item.tag_id"
							:onChange="() => setItem('tags', item.tag_id)"
						/>
						<label class="filter-modal__input-label-tag">
							{{ item.tag }}
						</label>
					</div>
				</div>
				<div v-if="currentModalFilter === 'author'" class="pb-3">
					<div
						class="filter-modal__input"
						v-for="item in resourceAuthor"
						:key="item.resource_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('author', item.resource_author)"
							:value="item.resource_id"
							:onChange="() => setItem('author', item.resource_author)"
						/>
						<label class="filter-modal__input-label">
							{{ item.resource_author }}
						</label>
					</div>
				</div>
				<div v-if="currentModalFilter === 'options'">
					<div
						class="filter-modal__input"
						v-for="item in chipsFromFilterPoll"
						:key="item.poll_answer_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('options', item.poll_answer_id)"
							:value="item.poll_answer_id"
							:onChange="() => setItem('options', item.poll_answer_id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.poll_answer }}
						</label>
					</div>
				</div>

				<div v-if="currentModalFilter === 'tracks'" class="pb-3">
					<div
						class="speaker-filter__wrapper__empty"
						v-if="eventTracks.length === 0 && !isFiltersLoading"
					>
						No tracks available.
					</div>
					<div
						v-else
						class="filter-modal__input"
						v-for="item in eventTracks"
						:key="item.track_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('tracks', item.track_id)"
							:value="item.track_id"
							:onChange="() => setItem('tracks', item.track_id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.track_name }}
						</label>
					</div>
				</div>
				<div v-if="currentModalFilter === 'speakers'">
					<div
						class="speaker-filter__wrapper__empty"
						v-if="speakerFilter.length === 0 && !isFiltersLoading"
					>
						No speakers available for this event
					</div>
					<div v-else v-for="item in speakerFilter" :key="item.id">
						<div
							@click="setItem('speakers', item.id)"
							:style="selectedUserStyle(item)"
							class="speaker-filter__wrapper u-cursor-pointer"
						>
							<div class="speaker-filter__wrapper__user-info">
								<Avatar
									:borderRadius="'square'"
									:size="52"
									:color="'#ffffff'"
									:avatar="item.speaker_logo"
									:defaultAvatar="'speaker'"
								/>
								<div class="speaker-filter__wrapper__user-info__info">
									<span
										class="speaker-filter__wrapper__user-info__info__name mb-1"
										>{{ item.speaker_name }}</span
									>
									<span class="speaker-filter__wrapper__user-info__info__title">{{
										item.speaker_title
									}}</span>
									<span class="speaker-filter__wrapper__user-info__info__title">{{
										item.speaker_company
									}}</span>
								</div>
							</div>
							<CustomCheckbox
								:isChecked="isInputActive('speakers', item.id)"
								:value="item.id"
								:onChange="() => setItem('speakers', item.id)"
							/>
						</div>
					</div>
				</div>

				<div v-if="currentModalFilter === 'category'" class="pb-3 mt-3">
					<div
						class="filter-modal__input"
						v-for="item in categoriesList"
						:key="item.category_id"
					>
						<CustomCheckbox
							:isChecked="isInputActive('category', item.category_id)"
							:value="item.category_id"
							:onChange="() => setItem('category', item.category_id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.category_name }}
						</label>
					</div>
				</div>
				<div v-if="currentModalFilter === 'type'" class="pb-3">
					<div class="filter-modal__input" v-for="item in resourceType" :key="item.id">
						<CustomCheckbox
							:isChecked="isInputActive('type', item.id)"
							:value="item.id"
							:onChange="() => setItem('type', item.id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.name }}
						</label>
					</div>
				</div>

				<div v-if="isCustomField" class="pb-3">
					<div
						class="filter-modal__input"
						v-for="item in currentCustomList"
						:key="item.id"
					>
						<CustomCheckbox
							:isChecked="isInputActive(currentModalFilter, item.id)"
							:value="item.id"
							:onChange="() => setItem(currentModalFilter, item.id)"
						/>
						<label class="filter-modal__input-label">
							{{ item.val }}
						</label>
					</div>
				</div>
				<div class="d-flex flex-column" v-if="currentModalFilter === 'date'">
					<AppDatePicker
						v-model="singleRaw"
						:type="datePickerType"
						:color="datePickerColor"
						:first-day-of-week="1"
						:min="convertTimestampToDate(isStart)"
						:max="convertTimestampToDate(isEnd)"
						:marked-dates="formattedMarkedDates"
						:disabled-weekdays="[]"
						:auto-apply="autoApplyOnPick"
						:showPresets="false"
						locale="en-En"
						@apply="onSinglePick"
						@clear="clearDate"
					/>
					<v-alert v-if="dateError" type="warning" dense class="mt-2">
						{{ dateError }}
					</v-alert>
				</div>
			</div>

			<div class="filter-modal__action-btn-wrapper">
				<button
					type="button"
					class="elevation-0 filter-modal__action-btn-wrapper__cancel-btn"
					@click="closeModal"
				>
					Cancel
				</button>

				<button
					type="button"
					class="filter-modal__action-btn-wrapper__apply-btn"
					:disabled="false"
					@click="applySelection"
				>
					Apply
				</button>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { startOfMonth, endOfMonth, sub } from 'date-fns'
import CustomCheckbox from '@/components/CustomCheckbox'
import AppDatePicker from '@/components/Modals/AppDatePicker.vue'
import Avatar from '@/components/Avatar'
import { debounce } from '@/utils/helpers'

const TAG_FILTER_BY_ROUTE = {
	threads: 'threads',
	resources: 'resources',
	resource: 'resources',
	events: 'events',
}

export default {
	components: { CustomCheckbox, AppDatePicker, Avatar },
	props: {
		chipsFromFilterPoll: {
			type: Array,
			default: () => [],
		},
		filterModalIsVisible: {
			type: Boolean,
			default: false,
		},
		currentModalFilter: {
			type: String,
			default: '',
		},
		currentModalLabel: {
			type: String,
			default: '',
		},
		selectedChips: {
			type: Object,
			default: () => ({}),
		},
		filters: {
			type: Object,
			default: () => ({}),
		},
		dateError: {
			type: String,
			default: '',
		},
		dateOption: {
			type: String,
			default: '',
		},
		dateRange: {
			type: Object,
			default: () => ({}),
		},
		isStart: { type: [Number, String], default: null },
		isEnd: { type: [Number, String], default: null },
		dateListEvent: { type: Array, default: null },
	},
	mounted() {
		if (this.filterModalIsVisible && this.currentModalFilter === 'date') {
			this.singleRaw = this.rangeToRaw(this.dateRange)
		}
	},

	methods: {
		...mapActions('resources', ['getResourcesTypes', 'getResourcesAuthors']),
		...mapActions('app', ['getSort']),
		...mapActions('tag', ['fetchTags', 'clearTags']),
		...mapActions('event', [
			'fetchEventCategories',
			'clearEventCategories',
			'getEventTracks',
			'getSpeakersFilterList',
		]),
		...mapActions('list', ['getList', 'getSortType']),
		...mapActions('post', ['getPollUsers']),
		getTagsPayload(payload = {}) {
			const filter = TAG_FILTER_BY_ROUTE[this.$route.name]
			return filter ? { ...payload, filter } : payload
		},
		selectedUserStyle(item) {
			return {
				border: this.isInputActive('speakers', item.id)
					? '2px solid var(--primary_color)'
					: '1px solid #e2e2e2',
				padding: this.isInputActive('speakers', item.id) ? '11px' : '12px',
			}
		},
		convertTimestampToDate(ts) {
			if (!ts) return null
			const date = new Date(ts * 1000)
			return date.toISOString().slice(0, 10)
		},
		rangeToRaw(range) {
			if (!range || (!range.from && !range.to)) return null

			const getDate = (s) => (s ? String(s).split(' ')[0] : null)

			if (this.isMonthOnly) {
				const from = getDate(range.from)
				const to = getDate(range.to)
				if (!from || !to) return null

				const start = new Date(from + 'T00:00:00')
				const endOf = this.generateAndFormatDate(endOfMonth(start))
				if (from.endsWith('-01') && to === endOf) {
					return from.slice(0, 7)
				}
				return null
			} else {
				const from = getDate(range.from)
				const to = getDate(range.to)
				return from && to && from === to ? from : null
			}
		},
		onSinglePick(val) {
			let from, to
			if (this.isMonthOnly) {
				from = this.formatMonthStart(val)
				to = this.formatMonthEnd(val)
			} else {
				from = this.formatDateStart(val)
				to = this.formatDateEnd(val)
			}
			this.singleRaw = val
			this.setItem('date', { date: { from, to }, option: 'custom' })
		},
		formatMonthStart(yyyyMM) {
			const d = new Date(`${yyyyMM}-01T00:00:00`)
			return `${this.generateAndFormatDate(d)} 00:00`
		},
		formatMonthEnd(yyyyMM) {
			const d = endOfMonth(new Date(`${yyyyMM}-01T00:00:00`))
			return `${this.generateAndFormatDate(d)} 23:59`
		},
		formatDateStart(yyyyMMdd) {
			return `${yyyyMMdd} 00:00`
		},
		formatDateEnd(yyyyMMdd) {
			return `${yyyyMMdd} 23:59`
		},
		clearDate() {
			this.singleRaw = null
			this.setItem('date', { date: { from: null, to: null }, option: 'clear' })
			if (this.autoApplyOnPick) {
				this.applySelection()
				this.closeModal()
			}
		},

		handleSortItemChange(field) {
			this.setItem('sort', field)
			this.$emit('handleEventSortValue', field)
			if (['my-agenda-events', 'event-agenda'].some((item) => this.$route.name === item)) {
				this.getSortType(field)
				this.applySelection()
			} else {
				this.applySelection()
			}
		},

		isInputActive(filter, name) {
			switch (filter) {
				case 'sort': {
					if (this.filters.field) {
						return this.filters.field === name
					} else {
						const defaultItem = this.currentSortList.find((item) => item.default === 1)
						return defaultItem && defaultItem.field === name
					}
				}
				default: {
					return this.selectedChips[filter] &&
						this.selectedChips[filter].some((chip) => chip === name)
						? true
						: false
				}
			}
		},

		sortingLists() {
			let name = this.$route.name
			switch (name) {
				case 'attendees': {
					this.getSort({ name: 'users', sources: 'attendeesList' })
					break
				}
				case 'users': {
					this.getSort({ name: 'users', sources: 'nearMeList' })
					break
				}
				case 'partners': {
					this.getSort({ name: 'partners', sources: 'exhibitorsList' })
					break
				}
				case 'polls-users':
				case 'event-session-speakers':
				case 'event-speakers': {
					this.getSort({ name: 'speakers', sources: 'speakersList' })
					break
				}
				case 'exhibitor-staff': {
					this.getSort({ name: 'users', sources: 'boothStaffList' })
					break
				}
				case 'threads': {
					this.getSort({ name: 'threads', sources: 'newsList' })
					break
				}
				case 'forums-by-category-id': {
					this.getSort({ name: 'forums', sources: 'forumsList' })
					break
				}
				case 'events': {
					this.getSort({ name: 'events', sources: 'eventsList' })
					break
				}
				case 'event-checkin': {
					this.getSort({ name: 'event-checkin', sources: 'checkInLogList' })
					break
				}
				case 'my-agenda-events': {
					this.getSort({ name: 'event-agenda', sources: 'agendaDaysList' })
					break
				}
				case 'event-agenda': {
					this.getSort({ name: 'event-agenda', sources: 'agendaList' })
					break
				}
				case 'resource':
				case 'resources': {
					this.getSort({ name: 'resources', sources: 'resourcesList' })
					break
				}
				default: {
					break
				}
			}
		},

		clearTimer() {
			clearTimeout(this.scrollTimer)
			this.scrollTimer = null
		},
		closeModal() {
			this.$emit('closeModal')
			if (this.currentModalFilter === 'tags') {
				this.clearTags()
			}
		},
		applySelection() {
			this.$emit('applySelection')
			this.searchText = ''
			if (this.currentModalFilter === 'date') {
				this.$emit('setDateDay', this.singleRaw)
			}
			if (this.currentModalFilter === 'tags') {
				this.clearTags()
			}
		},
		setItem(filter, item) {
			this.$emit('setItem', { filter, item })
		},
		generateAndFormatDate(date) {
			const year = date.getFullYear()
			const month = this.pad(date.getMonth() + 1)
			const day = this.pad(date.getDate())
			return year + '-' + month + '-' + day
		},
		generateAndFormatDateWithTime(value) {
			const date = new Date(value)
			const year = date.getFullYear()
			const month = String(date.getMonth() + 1).padStart(2, '0')
			const day = String(date.getDate()).padStart(2, '0')
			const hours = String(date.getHours()).padStart(2, '0')
			const minutes = String(date.getMinutes()).padStart(2, '0')

			return `${year}-${month}-${day} ${hours}:${minutes}`
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number
		},
		handleScroll() {
			if (!this.scrollTimer) {
				const container = this.$refs.filterContainer
				if (container.scrollTop + container.clientHeight >= container.scrollHeight - 5) {
					if (!this.isFiltersLoading && !this.isLastPage) {
						const increasePage = (num) => {
							const page = num + 1
							this.page = page
							return page
						}
						this.scrollTimer = setTimeout(() => {
							switch (this.currentModalFilter) {
								case 'author': {
									this.getResourcesAuthors({ page: increasePage(this.page) })
									break
								}
								case 'type': {
									this.getResourcesTypes({ page: increasePage(this.page) })
									break
								}
								case 'tags': {
									this.fetchTags(
										this.getTagsPayload({
											page: increasePage(this.page),
											search: this.searchText,
										})
									)
									break
								}
								case 'category': {
									this.fetchEventCategories({ page: increasePage(this.page) })
									break
								}
								case 'speakers': {
									this.getSpeakersFilterList({
										page: increasePage(this.page),
										eventId: this.$route.params.id,
									})
									break
								}
								case 'tracks': {
									this.getEventTracks({
										eventId: this.$route.params.id,
										page: increasePage(this.page),
									})
									break
								}
								default: {
									if (
										this.isCustomField &&
										this.listsMeta.some(
											(list) => list.source === this.currentModalFilter
										)
									) {
										this.getList({
											name: this.currentModalFilter,
											query: { page: increasePage(this.page) },
										})
									}
								}
							}
						}, 500)
					}
				}
			}
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('tag', ['tags', 'isTagsLoading', 'tagsMeta']),
		...mapGetters('event', [
			'categories',
			'isCategoriesLoading',
			'isTracksLoading',
			'categoriesMeta',
			'eventTracksMeta',
			'eventTracks',
			'speakerFilter',
			'isSpeakerFilterLoading',
			'speakerFilterError',
			'speakerFilterMeta',
		]),
		...mapGetters('app', ['sortLists', 'sortLoading']),
		...mapGetters('list', ['listsMeta', 'lists', 'isListsLoading', 'listsPageMeta']),
		...mapGetters('resources', [
			'resourceTypeMeta',
			'resourceType',
			'resourceAuthor',
			'resourceAuthorMeta',
		]),
		...mapGetters('post', ['postPollUsersLoading', 'postPollUsers', 'postPollUsersLoading']),
		formattedMarkedDates() {
			if (!this.dateListEvent) return []
			return this.dateListEvent.map((ev) => {
				const d = new Date(ev.events_agenda_from * 1000)
				const year = d.getFullYear()
				const month = String(d.getMonth() + 1).padStart(2, '0')
				const day = String(d.getDate()).padStart(2, '0')
				return `${year}-${month}-${day}`
			})
		},
		datePickerType() {
			const monthOnlyRoutes = ['events']
			return monthOnlyRoutes.includes(this.$route.name) ? 'month' : 'date'
		},
		isMonthOnly() {
			return this.datePickerType === 'month'
		},
		hasActiveDate() {
			return !!this.singleRaw
		},
		currentSortList() {
			if (!this.sortLists) {
				return []
			}
			return this.sortLists
		},

		computedTags() {
			return this.tags
		},

		chapters() {
			return this.profile && this.profile.chapters.filter((item) => !item.hidden_subgroup)
		},
		categoriesList() {
			return this.categories.map(({ category_id, category_name }) => {
				return { category_id, category_name }
			})
		},
		datePickerColor() {
			const { navigation_bar_tint: navigationBarTint } = this.styles || {}
			return navigationBarTint + ' !important'
		},
		isCustomField() {
			return this.defaultFilters.every((filter) => filter !== this.currentModalFilter)
		},
		currentCustomList() {
			if (
				this.defaultFilters.every((filter) => filter !== this.currentModalFilter) &&
				this.listsMeta.some((list) => list.source === this.currentModalFilter)
			) {
				return this.lists && this.lists[this.currentModalFilter]
					? this.lists[this.currentModalFilter]
					: []
			}
			return []
		},
		isFiltersLoading() {
			return (
				this.isCategoriesLoading ||
				this.isTagsLoading ||
				this.isListsLoading ||
				this.isTracksLoading ||
				this.isSpeakerFilterLoading
			)
		},
		isLastPage() {
			switch (this.currentModalFilter) {
				case 'speakers': {
					return this.speakerFilterMeta && +this.speakerFilterMeta.pageCount <= this.page
				}
				case 'author': {
					return this.resourceAuthorMeta && this.resourceAuthorMeta.pageCount <= this.page
				}
				case 'type': {
					return this.resourceTypeMeta && this.resourceTypeMeta.pageCount <= this.page
				}
				case 'tags': {
					return this.tagsMeta && this.tagsMeta.pageCount <= this.page
				}
				case 'category': {
					return this.categoriesMeta && this.categoriesMeta.pageCount <= this.page
				}
				case 'tracks': {
					return this.eventTracksMeta && this.eventTracksMeta.pageCount <= this.page
				}
				default: {
					if (!this.isCustomField || !this.listsPageMeta[this.currentModalFilter]) {
						return true
					} else {
						return +this.listsPageMeta[this.currentModalFilter].pageCount <= this.page
					}
				}
			}
		},
	},
	watch: {
		searchText(val) {
			this.searchTags(val)
		},
		filterModalIsVisible(val) {
			if (val && this.currentModalFilter === 'date') {
				this.singleRaw = this.rangeToRaw(this.dateRange)
			}
		},
		dateRange: {
			deep: true,
			handler(newVal) {
				if (this.filterModalIsVisible && this.currentModalFilter === 'date') {
					this.singleRaw = this.rangeToRaw(newVal)
				}
			},
		},
		dateOption(newVal) {
			if (newVal === 'clear') this.singleRaw = null
		},
		selectedOption(option) {
			let fromDate = ''
			// eslint-disable-next-line no-unused-vars
			let fromTime = ''
			let toDate = ''
			// eslint-disable-next-line no-unused-vars
			let toTime = ''

			const currentDate = new Date()

			switch (option) {
				case 'today':
					fromDate = this.generateAndFormatDate(currentDate)
					toDate = this.generateAndFormatDate(currentDate)

					break
				case 'yesterday': {
					const yesterday = sub(currentDate, { days: 1 })

					fromDate = this.generateAndFormatDate(yesterday)
					fromTime = '00:00'

					toDate = this.generateAndFormatDate(yesterday)
					toTime = '23:59'

					break
				}
				case 'last7days': {
					const last7DaysFrom = sub(currentDate, { days: 6 })

					fromDate = this.generateAndFormatDate(last7DaysFrom)
					toDate = this.generateAndFormatDate(currentDate)
					break
				}

				case 'last30days': {
					const last30DaysTo = currentDate
					const last30DaysFrom = sub(last30DaysTo, { days: 29 })

					fromDate = this.generateAndFormatDate(last30DaysFrom)
					toDate = this.generateAndFormatDate(last30DaysTo)

					break
				}
				case 'thisMonth': {
					const startThisMonth = startOfMonth(currentDate)
					const endThisMonth = endOfMonth(currentDate)

					fromDate = this.generateAndFormatDate(startThisMonth)
					toDate = this.generateAndFormatDate(endThisMonth)

					break
				}

				case 'lastMonth': {
					const endDate = sub(currentDate, { months: 1 })
					const startLastMonth = startOfMonth(endDate)
					const endLastMonth = endOfMonth(endDate)

					fromDate = this.generateAndFormatDate(startLastMonth)
					toDate = this.generateAndFormatDate(endLastMonth)

					break
				}

				default:
					fromDate = this.generateAndFormatDate(new Date())
					toDate = this.generateAndFormatDate(new Date())
			}
			this.setItem('date', {
				date: { to: `${toDate} 23:59`, from: `${fromDate} 00:00` },
				option,
			})
		},
		selectedFromTime(newValue) {
			this.setItem('date', {
				date: { from: newValue ? this.generateAndFormatDateWithTime(newValue) : null },
				option: newValue ? null : 'clear',
			})
		},
		selectedToTime(newValue) {
			this.setItem('date', {
				date: { to: newValue ? this.generateAndFormatDateWithTime(newValue) : null },
				option: newValue ? null : 'clear',
			})
		},
		tags() {
			this.clearTimer()
		},
		categories() {
			this.clearTimer()
		},
		speakerFilter() {
			this.clearTimer()
		},
		isListsLoading(newValue) {
			!newValue && this.clearTimer()
		},
	},
	created() {
		this.searchTags = debounce((val) => {
			this.page = 1
			this.clearTags()

			this.fetchTags(
				this.getTagsPayload({
					page: 1,
					search: val,
				})
			)
		}, 300)
		if (this.currentModalFilter === 'speakers') {
			const eventId = this.$route.params.id || this.$route.query.event_id
			const page = this.speakerFilter.length === 0 ? 1 : +this.speakerFilterMeta.currentPage
			this.page = page
			if (this.$route.name === 'sub-session-list') {
				const parentAgendaId = this.$route.query.events_agenda_id
				!this.speakerFilter?.length &&
					this.getSpeakersFilterList({
						eventId: eventId,
						parent_agenda_id: parentAgendaId,
						page,
					})
			} else {
				!this.speakerFilter?.length &&
					this.getSpeakersFilterList({ eventId: eventId, page })
			}
		}
		if (
			this.currentModalFilter === 'sort' &&
			!['event-speakers', 'event-session-speakers'].includes(this.$route.name)
		) {
			this.sortingLists()
		}
		if (this.currentModalFilter === 'author') {
			const page = this.resourceAuthor.length === 0 ? 1 : +this.resourceAuthorMeta.currentPage
			this.page = page
			!this.resourceAuthor.length && this.getResourcesAuthors({ page })
		}
		if (this.currentModalFilter === 'type') {
			const page = this.resourceType.length === 0 ? 1 : +this.resourceTypeMeta.currentPage
			this.page = page
			!this.resourceType.length && this.getResourcesTypes({ page })
		}
		if (this.currentModalFilter === 'tags') {
			const page = this.tags.length === 0 ? 1 : +this.tagsMeta.currentPage
			this.page = page
			this.fetchTags(this.getTagsPayload({ page }))
		} else if (this.currentModalFilter === 'category') {
			const page = this.categories.length === 0 ? 1 : +this.categoriesMeta.currentPage
			this.page = page
			!this.categories.length && this.fetchEventCategories({ page })
		} else if (
			this.isCustomField &&
			this.listsMeta.some((list) => list.source === this.currentModalFilter)
		) {
			const meta = this.listsPageMeta[this.currentModalFilter]
			const page = meta && meta.currentPage ? +meta.currentPage : 1
			this.page = page
			if (!this.lists[this.currentModalFilter]) {
				this.getList({ name: this.currentModalFilter, page })
			}
		}
	},
	data() {
		return {
			hasMoreItems: true,
			page: 1,
			selectedFromTime: null,
			selectedToTime: null,
			scrollTimer: null,
			activeDateTab: 'fixedPeriods',
			selectedOption: this.dateOption,
			singleRaw: null,
			autoApplyOnPick: true,
			searchText: '',
			isInputFocused: false,
			defaultFilters: [
				'clear',
				'chapters',
				'tags',
				'category',
				'date',
				'past',
				'myposts',
				'admin',
				'users',
				'register',
				'schedule',
				'categories',
				'follow',
				'sort',
			],
		}
	},
}
</script>
<style lang="scss">
.speaker-filter {
	&__wrapper {
		font-family: Inter, sans-serif;
		width: 100%;
		min-height: 105px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #e2e2e2;
		margin-bottom: 8px;
		border-radius: 8px;
		&__empty {
			height: 100%;
			display: flex;
			gap: 10px;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			color: #4a4a4a;
		}
		&:hover {
			background-color: #f3f3f6;
		}
		&__user-info {
			display: flex;
			align-items: center;
			gap: 12px;
			&__info {
				display: flex;
				flex-direction: column;
				&__name {
					font-weight: 700;
					font-size: 16px;
					line-height: 100%;
					letter-spacing: 0;
					color: var(--username-category-title);
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
					word-break: break-word;
				}
				&__title {
					font-weight: 400;
					font-size: 13px;
					line-height: 100%;
					letter-spacing: 0;
					color: var(--company-position-large);
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
					margin-bottom: 2px;
					word-break: break-word;
				}
			}
		}
	}
}
.v-picker__title {
	display: none;
}
.filter-modal .v-date-picker-table .v-btn--active {
	background-color: var(--calendar_point_tint) !important;
	color: #fff !important;
}
.v-date-picker-table {
	height: auto;
}
.sort-modal-container {
	display: flex;
	justify-content: flex-end;
	@media (max-width: 480px) {
		justify-content: center;
	}
}

.filter-modal-wrapper {
	position: absolute;
	margin-top: 20px;
	align-items: flex-end !important;
	z-index: 1000;
	background: white;
	border-radius: 10px;
	border: 1.5px solid #e2e2e2;
	width: 250px;
	max-height: fit-content;
	padding: 16px;
}

.filter-modal__sort__input {
	max-width: 100%;
	display: flex;
	padding: 12px;
	margin-top: 2px;
}

.filter-modal__sort__input.active {
	background-color: #f3f3f6 !important;
	color: #fff !important;
	border-radius: 8px;
}

.filter-modal__sort__input:hover {
	background-color: #f3f3f6;
	border-radius: 8px;
}

.filter-modal {
	border-radius: 13px;
	max-height: 800px !important;
	overflow-y: hidden;
	&__card {
		position: relative;
		padding: 24px;
		border-radius: 10px !important;

		&__close {
			position: absolute;
			top: 8px;
			right: 8px;
			cursor: pointer;
			z-index: 1;
		}
	}
	&__input-label {
		font-size: 16px;
		margin-left: 8px;
		color: var(--action_sheet_label);
		font-family: 'Inter', sans-serif;
	}
	&__action-btn-wrapper {
		display: flex;
		justify-content: center;
		gap: 16px;
		&__cancel-btn {
			width: 150px;
			height: 46px;
			color: var(--button-secondary-background-color);
			border: 1.5px solid var(--button-secondary-background-color);
			border-radius: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
		}
		&__apply-btn {
			width: 150px;
			height: 46px;
			background-color: var(--button-main-background-color);
			color: var(--button-main-color);
			border-radius: 8px;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
		}
	}

	&__container {
		max-height: 500px;
		overflow-y: auto;
		overscroll-behavior: contain;
		@media (max-height: 750px) {
			max-height: 50vh;
		}
	}

	&__input {
		margin: 16px 0;
		display: flex;
		align-items: center;
		gap: 8px;

		&-label {
			font-size: 16px;
			font-family: 'Inter', sans-serif;
			color: var(--username-category-title);
			position: relative;
			top: 1px;
		}
	}

	&__progress {
		position: absolute;
		left: calc(100% + 12px);
		top: 50%;
		transform: translateY(-50%);
	}

	&__title {
		position: relative;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		width: 80%;
		display: flex;
		align-items: center;
		gap: 24px;
	}

	&__action-btn {
		border-radius: 8px !important;
		text-transform: capitalize;
		font-size: 16px;
		font-weight: 700;
		box-shadow: none !important;
		padding: 0 32px !important;

		@media (max-width: 480px) {
			flex-grow: 1;
			padding: 0 !important;

			&-wrapper {
				display: flex;
				flex-wrap: nowrap;
			}
		}
	}

	.action-cancel {
		background-color: #fff !important;
		color: var(--accent-color) !important;
		border: 2px solid var(--accent-color);
		margin-right: 8px;
	}

	.action-apply {
		margin-left: 8px;
	}
}
</style>
